/* CZ SKU-Suche im Dropdown — Artikelnummern direkt im Suchvorschlag.

   Problem: Die Herstellernummer (406881-02, S101245-1094) steht im Metafeld
   custom.sku, das Shopifys Suche nicht durchsucht. Das Dropdown rendert
   serverseitig Shopifys Ergebnis — fuer eine Nummer also "keine Treffer".

   Loesung: Dieses Script beobachtet die Sucheingabe (Desktop-Dropdown UND
   Mobil-Dialog, beide ueber form[aria-owns] -> <predictive-search>). Sieht
   der Begriff nach einer Nummer aus (vier Ziffern am Stueck), laedt es den
   Index aus templates/collection.cz-sku-index.liquid (250 je Seite, sechs
   Stunden im Browser gecacht) und sucht selbst. Treffer werden als
   Produktzeilen mit exakt den Klassen von predictive-search-result-item
   oben in das Dropdown gesetzt — Bild, Marke, Titel, Preis kommen per
   /products/{handle}.js, erste eigene Anfrage, kein Fremdserver.

   Die Komponente ersetzt ihren Inhalt bei jedem Tastendruck. Ein
   MutationObserver setzt die Treffer danach wieder ein. Es wird NICHT
   reparentet und nichts an der Komponente veraendert (siehe Tab-Switch-
   Bug in cz-header-animations.js) — nur ein Kind eingefuegt.

   WICHTIG — Shadow DOM: <predictive-search> hat eine Shadow-Root mit
   <slot name="results">. Gerendert wird NUR div.predictive-search__content
   [slot=results]. Ein direktes Kind daneben haengt zwar im DOM, liegt aber
   nicht im Render-Baum (Hoehe 0, leere Computed-Styles — live gemessen).
   Der Block gehoert deshalb IN diesen Container, bzw. in die Ergebnisbox
   darin. Gibt es den Container noch nicht, traegt der Block selbst
   slot="results". */
(function () {
  'use strict';
  var KEY = 'cz-sku-index-v1';
  var MAX_HITS = 3;
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var indexBase = root + '/collections/all?view=cz-sku-index&page=';

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function looksLikeSku(t) { return /\d{4,}/.test(t) && norm(t).length >= 4; }

  /* ── Index laden (einmal je Seite, sonst aus sessionStorage) ── */
  var indexPromise = null;
  function fetchPage(n) {
    return fetch(indexBase + n, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function loadIndex() {
    if (indexPromise) return indexPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.items && c.t > Date.now() - 21600000) { indexPromise = Promise.resolve(c.items); return indexPromise; }
    } catch (e) {}
    indexPromise = fetchPage(1).then(function (first) {
      var reqs = [];
      for (var p = 2; p <= (first.pages || 1); p++) reqs.push(fetchPage(p).then(function (j) { return j.items; }));
      return Promise.all(reqs).then(function (rest) {
        var items = first.items.concat.apply(first.items, rest);
        try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        return items;
      });
    }).catch(function (e) { indexPromise = null; throw e; });
    return indexPromise;
  }
  function findHits(items, term) {
    var q = norm(term);
    return items.filter(function (it) {
      var s = norm(it.s), v = norm(it.v);
      return (s && (s === q || s.indexOf(q) === 0)) || (v && v.indexOf(q) !== -1);
    }).slice(0, MAX_HITS);
  }

  /* ── Produktdaten fuer die Zeile ── */
  var productCache = {};
  function productData(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + '/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  /* Betrag im Geldformat des Shops (shop.money_format ueber themeVariables),
     genau wie Shopify: Platzhalter amount, amount_with_comma_separator usw.,
     HTML (z. B. <span class=money>) entfernt. Vorher Browser-Sprache via
     Intl - auf /en stand dann "€10.00" statt des Shop-Formats. */
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{amount_with_comma_separator}} €';
    fmt = String(fmt).replace(/<[^>]*>/g, '');
    function delim(precision, thousands, decimal) {
      var parts = (cents / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(0, ',', '.');
        case 'amount_with_comma_separator': return delim(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(0, '.', ',');
        case 'amount_with_space_separator': return delim(2, ' ', ',');
        case 'amount_with_period_and_space_separator': return delim(2, ' ', '.');
        case 'amount_with_apostrophe_separator': return delim(2, "'", '.');
        default: return delim(2, ',', '.');
      }
    }).trim();
  }
  function imgUrl(u) {
    if (!u) return '';
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=120';
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  /* Gleiche Struktur wie snippets/predictive-search-result-item.liquid (product) */
  function row(p, hit) {
    var a = el('a', 'predictive-search__item product-item');
    a.href = p && p.url ? p.url : root + '/products/' + hit.h;
    a.setAttribute('data-instant', '');
    if (p && p.featured_image) {
      var img = el('img', 'product-item__image');
      img.src = imgUrl(p.featured_image); img.alt = p.title || ''; img.width = 60; img.height = 60; img.loading = 'lazy';
      a.appendChild(img);
    }
    var info = el('div', 'product-item__info');
    var title = (p && p.title) || hit.t || hit.h;
    if (p && p.vendor) {
      info.appendChild(el('span', 'product-item__vendor text-xxs text-subdued uppercase tracking-widest', p.vendor));
      if (title.indexOf(p.vendor) === 0) title = title.slice(p.vendor.length).trim();
    }
    info.appendChild(el('span', 'product-item__title h6', title));
    var pl = el('div', 'product-item__price-list price-list');
    if (p && typeof p.price === 'number') {
      if (p.compare_at_price && p.compare_at_price > p.price) {
        pl.appendChild(el('span', 'price price--highlight', money(p.price)));
        pl.appendChild(el('span', 'price price--compare', money(p.compare_at_price)));
      } else {
        pl.appendChild(el('span', 'price', money(p.price)));
      }
    }
    /* Die gesuchte Nummer sichtbar bestaetigen */
    pl.appendChild(el('span', 'text-xxs text-subdued cz-sku-hit__code', hit.s || ''));
    info.appendChild(pl);
    a.appendChild(info);
    return a;
  }

  /* ── Einsetzen ins Dropdown ── */
  function render(ps, hits) {
    var block = ps.querySelector('[data-cz-sku-hit]');
    var results = ps.querySelector('.predictive-search__results');
    if (!block) {
      block = el('div', '');
      block.setAttribute('data-cz-sku-hit', '');
    }
    block.innerHTML = '';
    /* Ohne Shopify-Ergebnis stellt der Block selbst die Ergebnisbox dar
       (gleiche Klasse -> gleiche Glas-Box auf dem Desktop); mit Ergebnis
       sitzt er als erster Eintrag IN der Box, damit nicht zwei Boxen
       uebereinander stehen. */
    block.className = results ? 'cz-sku-hit' : 'predictive-search__results cz-sku-hit';
    block.appendChild(el('p', 'predictive-search__category h6 text-subdued', 'Artikelnummer'));
    var list = el('div', 'predictive-search__products predictive-search__products--scroll');
    list.style.setProperty('--product-list-items-per-row', '1');
    block.appendChild(list);
    hits.forEach(function (hit) {
      var placeholder = row(null, hit);
      list.appendChild(placeholder);
      productData(hit.h).then(function (p) {
        if (!p || !placeholder.parentNode) return;
        placeholder.parentNode.replaceChild(row(p, hit), placeholder);
      });
    });
    var content = ps.querySelector('.predictive-search__content');
    var host = results || content;
    if (host) {
      block.removeAttribute('slot');
      if (block.parentNode !== host || host.firstChild !== block) host.insertBefore(block, host.firstChild);
    } else {
      block.setAttribute('slot', 'results');
      if (block.parentNode !== ps) ps.insertBefore(block, ps.firstChild);
    }
    var nr = ps.querySelector('.predictive-search__no-results');
    if (nr) nr.hidden = true;
  }
  function clear(ps) {
    var block = ps.querySelector('[data-cz-sku-hit]');
    if (block) block.parentNode.removeChild(block);
    var nr = ps.querySelector('.predictive-search__no-results');
    if (nr) nr.hidden = false;
  }

  /* ── Eine Eingabe + ihr Dropdown verdrahten ── */
  function wire(input, ps) {
    var state = { term: '', hits: null, timer: null };
    function evaluate() {
      var term = input.value.trim();
      if (!looksLikeSku(term)) { state.term = ''; state.hits = null; clear(ps); return; }
      loadIndex().then(function (items) {
        if (input.value.trim() !== term) return;
        var hits = findHits(items, term);
        state.term = term; state.hits = hits;
        if (hits.length) render(ps, hits); else clear(ps);
      }).catch(function () { clear(ps); });
    }
    input.addEventListener('input', function () {
      clearTimeout(state.timer);
      state.timer = setTimeout(evaluate, 150);
    });
    /* Index beim ersten Fokus vorladen (einmalig, ~30 KB komprimiert): kalt
       dauerte der erste Artikelnummern-Treffer mehrere Sekunden, weil vier
       Seiten nachgeladen wurden. Wer tippt, hat vorher fokussiert. */
    input.addEventListener('focus', function () { loadIndex().catch(function () {}); }, { once: true });
    /* Die Komponente tauscht ihren Inhalt bei jeder Antwort aus — danach
       den Treffer wieder einsetzen. Eigene Einfuegungen loesen ebenfalls
       Mutationen aus; die werden am Attribut erkannt und ignoriert. */
    new MutationObserver(function (records) {
      /* Eigene Aenderungen: alles INNERHALB des Blocks (target im Block)
         sowie das Ein-/Aushaengen des Blocks selbst. Alles andere stammt
         von der Komponente — dann neu einsetzen. render() ist idempotent,
         eine Schleife kann so nicht entstehen. */
      var own = records.every(function (r) {
        if (r.target && r.target.nodeType === 1 && r.target.closest('[data-cz-sku-hit]')) return true;
        var isBlock = function (n) { return n.nodeType === 1 && n.hasAttribute('data-cz-sku-hit'); };
        return Array.prototype.every.call(r.addedNodes, isBlock) && Array.prototype.every.call(r.removedNodes, isBlock);
      });
      if (own) return;
      if (state.hits && state.hits.length && input.value.trim() === state.term) render(ps, state.hits);
    }).observe(ps, { childList: true, subtree: true });
  }

  function init() {
    var forms = document.querySelectorAll('form[aria-owns]');
    Array.prototype.forEach.call(forms, function (form) {
      var input = form.querySelector('input[name="q"]');
      var ps = document.getElementById(form.getAttribute('aria-owns'));
      if (!input || !ps || ps.tagName.toLowerCase() !== 'predictive-search' || ps.dataset.czSkuWired) return;
      ps.dataset.czSkuWired = '1';
      wire(input, ps);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
